import React from 'react';
import { log, toWapi } from '../../util/api';
import _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import DirectionsIcon from '@mui/icons-material/Directions';
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

/* const RefreshBtn = (props) => {
	const [loading, setLoading] = React.useState(false);
	function onclick() {
		setLoading(true);
		get('/maytapi/refreshSubscription/' + props.uid).then(() => {
			setLoading(false);
		});
	}

	return <Button onClick={onclick} loading={loading} icon="refresh" />;
}; */

export default function Footprint() {
	const [loading, setLoading] = React.useState(true);
	const [nloading, setNLoading] = React.useState(false);
	const [data, setData] = React.useState({});
	//const [list, setList] = React.useState({});
	//const [onlysubs, setOnlySubs] = React.useState(false);
	//const [multiInstance, setMultiInstance] = React.useState(false);

	React.useEffect(() => {
		log('/footprint/harvest/getPhoneStatuses').then((temp) => {
			setLoading(false);
			console.log('temp', temp);
			setData({
				list: _.orderBy(temp.data.result, ['date'], ['desc']),
			});
			//setList(_.orderBy(temp.data.result, ['date'], ['desc']));
		});
	}, []);
	if (loading) return <Box attached="bottom">loading...</Box>;

	const { column, list, direction } = data;
	function handleSort(clickedColumn) {
		return () => {
			if (column !== clickedColumn) {
				setData({
					column: clickedColumn,
					list: _.sortBy(list, [clickedColumn]),
					direction: 'ascending',
				});

				return;
			}

			setData({
				column: clickedColumn,
				list: list.reverse(),
				direction: direction === 'ascending' ? 'descending' : 'ascending',
			});
		};
	}

	let filteredlist = data.list;
	/* if (onlysubs) {
		filteredlist = _.filter(list, (it) => it.subscription);
	}
	if (multiInstance) {
		filteredlist = _.filter(list, (it) => it.sessionId);
	} */
	async function getStatus({ pid, wapi_token, phone_id }) {
		let selected_index = _.findIndex(data.list, { phone_id });
		setNLoading(true);
		await toWapi(`/api/${pid}/${phone_id}/status`, wapi_token).then((result) => {
			let status_data = result.data;
			let updatedStatus = 'active';
			if (status_data.status.connRetry) updatedStatus = 'no internet';
			else if (status_data.status.isQr) updatedStatus = 'qr-screen';
			else if (status_data.status.loading) updatedStatus = 'loading';
			else if (status_data.status.message) updatedStatus = 'phone-error';
			else if (status_data.status.loggedIn) updatedStatus = 'active';
			else updatedStatus = 'other';
			//console.log('yyy', updatedStatus);
			let temp_list = data.list;
			temp_list[selected_index].new_status = 'new: ' + updatedStatus;
			//console.log(temp_list);
			setData({ list: temp_list });
			setNLoading(false);
		});
	}
	console.log('sssss', list);
	return (
		<Box attached="bottom">
			{/* <Form>
				<Form.Group>
					<Form.Field>
						<label>Only Subs</label>
						<Form.Checkbox toggle name="onlysubs" checked={onlysubs} onClick={() => setOnlySubs(!onlysubs)}></Form.Checkbox>
					</Form.Field>
					<Form.Field>
						<label>Multi-Instance</label>
						<Form.Checkbox toggle name="multiInstance" checked={multiInstance} onClick={() => setMultiInstance(!multiInstance)}></Form.Checkbox>
					</Form.Field>
				</Form.Group>
			</Form> */}
			<Table sortable celled>
				<TableHead>
					<TableRow>
						<TableCell textAlign="center" style={{ width: 70 }} collapsing sorted={column === 'id' ? direction : null} onClick={handleSort('id')}>
							ID
						</TableCell>
						<TableCell>Email</TableCell>
						<TableCell sorted={column === 'new_status' ? direction : null} onClick={handleSort('new_status')}>
							New Status
						</TableCell>
						<TableCell sorted={column === 'date' ? direction : null} onClick={handleSort('date')}>
							Date
						</TableCell>
						<TableCell>
							<Button loading={nloading} />
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{_.map(filteredlist, (it) => {
						let { email, pid, new_status, date, phone_id, wapi_token } = it;
						//console.log(subscription);
						return (
							<TableRow key={phone_id}>
								<TableCell textAlign="center">
									<CopyToClipboard text={'copy_text'}>
										<span>
											{phone_id}
											<a
												href={`https://api.maytapi.com/api/${pid}/${phone_id}/screen?token=${wapi_token}`}
												target="_blank"
												rel="noopener noreferrer"
											>
												<DirectionsIcon />
											</a>
										</span>
									</CopyToClipboard>
								</TableCell>
								<TableCell>{email}</TableCell>

								<TableCell>{new_status}</TableCell>
								<TableCell>{moment(date).format('DD-MM-YYYY')}</TableCell>
								<TableCell>
									<Button loading={nloading} onClick={() => getStatus({ pid, wapi_token, phone_id })}>
										Get Status
									</Button>
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</Box>
	);
}
